import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-tenure-modifier',
  templateUrl: './tenure-modifier.component.html',
  styleUrls: ['./tenure-modifier.component.scss'],
})
export class TenureModifierComponent {
  @Input() tenures: any;
  @Input() amount!: number;
  @Input() amountModify: boolean = true;
  @Input() installment: boolean = true;
  @Input() offer!: any;

  @Output() modify = new EventEmitter<void>();
  @Input() currentValue = new EventEmitter<any>();
  @Output() currentValueChange = new EventEmitter<any>();
  modifyAmount() {
    this.modify.emit();
  }

  select(item: any) {
    this.currentValueChange.emit(item);
  }
}
